import { render } from "./PersonalInfo.vue?vue&type=template&id=6d6bb73e"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"

import "./PersonalInfo.vue?vue&type=style&index=0&id=6d6bb73e&lang=css"

import exportComponent from "/Users/gokaysen/Desktop/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__